module.exports = __webpack_public_path__ + "static/img/digita_03.e342df66.jpg";